export const RealmScriptTypes = {
  REALM_MODULE: "module/realm",
  JS: "application/javascript",
  MODULE: "module",
} as const;
